import { ErrorMapping } from 'core/types/error-mapping';

export const TRANSL_STRG_AUT_RULES = 'settings.system.automation-rules.fields.type.';

export const ERRORS_MAPPINGS_AUTOMATION_RULES: ErrorMapping[] = [
    { field: 'name', errorCode: 'E_POC_SC_RES_0017', type: 'duplicated' },
];
